import {SousMenuItemAggregate} from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import {AutorisationsAggregate} from '../../../../../aggregats/autorisation/autorisations.aggregate';
import {AutorisationAggregate} from '../../../../../aggregats/autorisation/autorisation.aggregate';
import {FonctionLogicielle} from '../../../../fonctions-logicielle-constantes';
import {EparcoursPath} from '../../eparcours-path';

export const monCompteSousMenuItem = new SousMenuItemAggregate(
  'Mon Compte',
  '/monCompte', // todo: à remplacer par la constante quand la page sera créée
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.MonCompte)]),
  'icon-account-circle',
);

export const mesParametresSousMenuItem = new SousMenuItemAggregate(
  'Mes paramètres',
  '/mesParametres', // todo: à remplacer par la constante quand la page sera créée
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.MesParametres)]),
  'icon-settings2',
);

export const deconnexionSousMenuItem = new SousMenuItemAggregate(
  'Déconnexion',
  `/${EparcoursPath.root.LOGOUT}`,
  null,
  'icon-power1',);
